import { Queries } from "../services/queries";
import Popup from 'reactjs-popup';
import React, { useState } from "react";
import {WEBSERVER} from "../services/globals";
import { useCart } from "../components/providers/CartProvider";
import { IActiveOrder } from "./contracts/types";



 export default function PlaceCartComponent({idnr ,qty,  select}) {

  const { count, reloadCart, setCartCount } = useCart(); 

  let cnt:number  = parseInt(qty);
 
  function gotocart() {
    window.location.href=`${WEBSERVER}/cart`;
  }
  let disabled:string = "btn btn-primary incartbutton disabled";

  //ohne Listbox "disabled" entfernen
  if (select == null) {
    disabled = "btn btn-primary incartbutton";
  }

  async function handleClick() {
 

    if (select != null) {
       idnr = (document.getElementById(select) as HTMLInputElement).value;
    } else {
      disabled = "btn btn-primary incartbutton";
    } 
    const queries = new Queries(null);
    const result = await  queries.placeCart(idnr,cnt) as any;

    const c = result?.lines.length;
    
    console.log('\n+++placecart++++++++' + c +'-',JSON.stringify(result));
    
    if (result?.lines) {
      setCartCount(result.lines.length); // Positionsanzahl direkt aus Response
    } else {
      reloadCart(); // Fallback: neu vom Server laden
    }
        
  }

  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setOpen(false);
    //reloadCart();
  }  
  //console.log("product:~~~~~~~~" +  JSON.stringify(product));
  

  let cname="id_" + idnr;
     return  ( <div>
      <button className={disabled} id={cname} onClick={() => {handleClick(); setOpen(o => !o) }}>in Warenkorb</button>
      <Popup open={open} closeOnDocumentClick onClose={closeModal} className="">
                <div className="modalx animate">
  <div className="text-center">Artikel ist im Warenkorb</div><h1 className="text-center"><i className="bi bi-check font-weight-bold"></i></h1>
  <div className="d-flex justify-content-between">
  <button className="btn btn-secondary" onClick={closeModal}>weiter einkaufen</button>
  &nbsp;
  <button className="btn btn-primary" onClick={gotocart}>zum Warenkorb</button>
  </div>
     </div>
   </Popup>
      </div>);
  
 };
 
